// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/Debug.scss
// module id = 2233
// module chunks = 0